import React, { useState, useEffect } from 'react'
import { IntlProvider } from 'react-intl'
import { languageStrings } from './LocaleProvider'
import { availableLocales } from 'lib/localization'
import { Map } from 'immutable'

const langFromConfig = window.rwgps?.config.locale.slice(0, 2)

const StandaloneLocaleProvider = ({ children, language, locale }) => {
  const [langs, setLangs] = useState(Map({}))

  const renderLanguage = language ?? (availableLocales.includes(langFromConfig) > 0 ? langFromConfig : 'en')

  useEffect(() => {
    if (renderLanguage === 'en') { return }
    languageStrings(renderLanguage).then(strings => {
      setLangs(langs.set(renderLanguage, strings))
    })
  }, [language])

  let renderLocale = locale ?? window.rwgps?.config.locale
  if (renderLanguage !== 'en' && !langs.get(renderLanguage)) { return null }

  const messages = langs.get(renderLanguage)
  return (
    <IntlProvider locale={renderLocale} defaultLocale='en' messages={messages} key={langs}>
      {children}
    </IntlProvider>
  )
}

export default StandaloneLocaleProvider
